module.exports = "pegasus/assets/blue-ghost-twitter-old.png";